import React, { FC } from "react";
import { QRCodeSVG } from "qrcode.react";

type QRCodeProps = {
  url: string;
};

export const QRCode: FC<QRCodeProps> = ({ url }) => <QRCodeSVG value={url} />;
